import { Loader } from "./components/Loader";

export function LoadingScreen() {
  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <Loader />
    </div>
  );
}
